module.exports = __webpack_public_path__ + "img/woo.2efefe9e.svg";